export default {
  en: {
    'bundles-polish-sku.title': 'Polish SAF - T',
    'bundles-polish-sku.no-results-title': 'No Polish registration found',
    'bundles-polish-sku.no-results-description':
      'This feature only applies to entities with Polish registrations.',
    'bundles-polish-sku.download-template': 'Download Template',
    'bundles-polish-sku.upload-template': 'Upload Template',
    'bundles-polish-sku.delete-all': 'Delete all',
    'bundles-polish-sku.save': 'Save',
    'bundles-polish-sku.add-row': 'Add a row',
    'bundles-polish-sku.duplicate-sku': 'Please remove duplicate SKU or Product codes',
    'bundles-polish-sku.save.success-message:': 'SKU/Product codes updated successfully',
    'bundles-polish-sku.save.error-message':
      'Failed to update SKU/Product codes. Please try again.',
    'bundles-polish-sku.delete.success-message:': 'SKU/Product codes deleted successfully',
    'bundles-polish-sku.delete.error-message':
      'Failed to delete SKU/Product codes. Please try again.',
    'bundles-polish-sku.delete.confirm-message':
      'Are you sure you want to delete all SKU/product codes associated with this entity?',
    'bundles-polish-sku.download-template.error-message':
      'Failed to download template. Please try again.',
    'bundles-polish-sku.upload-template.success-message': 'SKU/Product codes imported successfully',
    'bundles-polish-sku.upload-template.error-message':
      'Failed to import SKU/Product codes. Please try again.',
  },
};
